module.exports = __webpack_public_path__ + "img/leftvector.297a80e2.svg";